export default __webpack_public_path__ + "static/media/Proposal.146415b0.xlsx";